import { z } from "zod";

export const EnrolleeStatus = z.enum([
  "UnderReview",
  "CertificatePending",
  "InsuranceCreditApprovalPending",
  "Excluded",
  "Enrolled",
  "InCloseOut",
  "Cancelled",
  "Closed",
]);

export type EnrolleeStatusEnum = z.infer<typeof EnrolleeStatus>;

export const EnrolleeStatusDisplayName: Record<EnrolleeStatusEnum, string> = {
  [EnrolleeStatus.enum.UnderReview]: "Under Review",
  [EnrolleeStatus.enum.CertificatePending]: "Certificate Pending",
  [EnrolleeStatus.enum.InsuranceCreditApprovalPending]:
    "Ins. Credit Approval Pending",
  [EnrolleeStatus.enum.Excluded]: "Excluded",
  [EnrolleeStatus.enum.Enrolled]: "Enrolled",
  [EnrolleeStatus.enum.InCloseOut]: "In Close Out",
  [EnrolleeStatus.enum.Cancelled]: "Cancelled",
  [EnrolleeStatus.enum.Closed]: "Closed",
};
